import { useStaticQuery, graphql } from 'gatsby';
import { usePageContext } from 'gatsby-theme-thepuzzlers-core';

export const useSolutionBuyPageContent = () => {
  const { locale } = usePageContext();

  const data = useStaticQuery(graphql`
    query {
      en: solutionBuyPageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
      de: deSolutionBuyPageContentJson {
        benefits {
          solution_benefits {
            data {
              description
              headline {
                html
              }
              list {
                text
              }
            }
          }
        }
        header {
          description
          caption
          headline {
            html
          }
          image {
            alt
            image {
              childImageSharp {
                gatsbyImageData(placeholder: TRACED_SVG)
              }
            }
          }
        }
      }
    }
  `);

  return data[locale];
};
